export default __webpack_public_path__ + "static/truck-16628e289f8bdd81d66badad3b4baae4.gif";